import { TFunction } from 'next-i18next'
import { OffsetOptionalKeys } from '../models/developers-slice.interface'

export const getOptionalFieldWithExcelData = (offsetOptionalKeys: OffsetOptionalKeys, excelData: object) => {
  let values: {field: string, value: string | number}[] = []
  Object.keys(offsetOptionalKeys).forEach(function (field) {
    if (offsetOptionalKeys[field]) {
      values.push({ field, value: excelData[offsetOptionalKeys[field]] })
    }
  })
  return values
}

export const getOffsetPreviewErrorLabel = (t: TFunction, purchaseData: any[], selectedProjectId: number): string => {
  if (purchaseData.length === 0) return t('developers.OffSet.PurchasesWarging')
  if (!selectedProjectId) return t('developers.OffSet.ProjectsWarning')
  return ''
}
